import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import type { IndividualCompetitionResult } from '../types/api.types';

interface IndividualResultTableProps {
  results: IndividualCompetitionResult[] | null | undefined;
}

export default function IndividualResultTable({ results }: IndividualResultTableProps) {
  if (results == null || results.length === 0) {
    return <p>No results</p>;
  }

  const resultRows = results.map((result) => (
    <tr key={`${result.firstName || ''}-${result.surname || ''}-${result.memberID}`}>
      <td style={{ verticalAlign: 'middle' }}>{result.position}</td>
      <td style={{ verticalAlign: 'middle', padding: '1px' }}>
        <Link to={`/members/${result.memberID}`}>
          <img src={`/assets/${result.memberID}.jpg`} height="45px" alt="" />
          <span>{` ${result.firstName} ${result.surname}`}</span>
        </Link>
      </td>
      <td style={{ verticalAlign: 'middle' }}>{result.points}</td>
    </tr>
  ));

  return (
    <Row>
      <Col md={12}>
        <table className="table">
          <thead>
            <tr>
              <th>Pos</th>
              <th>Player</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>{resultRows}</tbody>
        </table>
      </Col>
    </Row>
  );
}
